/* eslint-disable react/display-name */

import {useDispatch, useSelector} from "react-redux";
import {Navigate, useLocation} from "react-router-dom";
import {getCookie} from "react-use-cookie";
import {t} from "i18next";

import {getCurrentUserRole, selectIsAuth, setPreviousUserLocation} from "../../slices/UserSlice";
import useLocationPermission from "../adminForms/Ba3aSettings/tabs/PositionsSettings/useLocationPermission";

export function withRoleRequired(WrappedComponent) {
  return function (props) {
    const dispatch = useDispatch();
    const isAuth = useSelector(selectIsAuth);
    const token = getCookie("access_token");
    const role = useSelector(getCurrentUserRole) || null;
    // const isSuperUser = role === ROLES.SUPER_USER;
    // const allowedRoutes = useSelector(getCurrentUserRoutes);
    // const allPermissions = useSelector(selectAllPositionPermissions);

    const location = useLocation();

    const superRoutes = ["main", "settings", "references", "devIT"];
    const currentPath = location?.pathname.replace("/ba3a/", "");
    const nestedPaths = currentPath.split("/");

    // const ifAllowed =
    //   isSuperUser ||
    //   allowedRoutes?.filter(route => {
    //     if (currentPath.includes("bos")) {
    //       return route.routeUrl.includes(nestedPaths[0] + "/bos");
    //     }
    //     return route.routeUrl === nestedPaths[0] + "/*";
    //   });

    const {isNotAllowed} = useLocationPermission();

    if (!isAuth && !token) {
      setTimeout(() => dispatch(setPreviousUserLocation(location?.pathname)), 100);
      return <Navigate to="/login" replace />;
    }
    if (superRoutes.includes(nestedPaths[0])) {
      return <WrappedComponent {...props} />;
    }

    if (role && isNotAllowed) {
      return (
        <div className="flex_container jcc aic" style={{width: "100%", height: "100%"}}>
          <p> {t("You have no access to this page")}</p>
        </div>
      );
    }

    return <WrappedComponent {...props} />;
  };
}
